import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { BrowserRouter, HashRouter, Route, Routes } from "react-router-dom";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import ShipviaList from "../pages/Shipvia/ShipviaList";
import CreateShipvia from "../pages/Shipvia/CreateShipvia";
import EditShipvia from "../pages/Shipvia/EditShipvia";

export const queryClient = new QueryClient();

const Router = () => {
  return (
    <QueryClientProvider client={queryClient}>
      <HashRouter>
        <Routes>
          <Route path="/" element={<ShipviaList />} />
          <Route path="/create" element={<CreateShipvia />} />
          <Route path="/edit/:id" element={<EditShipvia />} />
        </Routes>
      </HashRouter>
      <ToastContainer autoClose={500} draggablePercent={30} />
    </QueryClientProvider>
  );
};

export default Router;
